// extracted by mini-css-extract-plugin
export default {"container":"v0-z"};